import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { X, ChevronRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { groupSubtitles, ITEM_DESCRIPTIONS, isPathActive } from './fioriNav';

// SAP-Fiori-artiges Modul-Panel: zeigt die Unterpunkte einer Top-Kategorie
// als Kacheln im Content-Bereich. Klick auf eine Kachel nutzt die bestehende Route.
export default function FioriModulePanel({ group, badges = {}, onNavigate, onClose }) {
  const { t } = useLanguage();
  const location = useLocation();
  const panelRef = useRef(null);
  const subtitles = groupSubtitles(t);

  // Fokus auf erste Kachel fuer Tastaturbedienung (ohne Scroll-Sprung)
  useEffect(() => {
    const first = panelRef.current?.querySelector('.fs-modtile');
    first?.focus({ preventScroll: true });
  }, [group?.id]);

  if (!group) return null;
  const badgeFor = (item) => (item.badgeKey ? (badges[item.badgeKey] || 0) : 0);

  return (
    <section
      className="fs-modpanel"
      ref={panelRef}
      role="region"
      aria-label={group.label}
      data-testid={`fiori-module-panel-${group.id}`}
    >
      <div className="fs-modpanel-inner">
        <div className="fs-modpanel-head">
          <div>
            <h2 className="fs-modpanel-title">{group.label}</h2>
            {subtitles[group.id] && <p className="fs-modpanel-sub">{subtitles[group.id]}</p>}
          </div>
          <button
            className="fs-icon-btn"
            onClick={onClose}
            aria-label={t('common.close', 'Schließen')}
            data-testid="fiori-module-close"
          >
            <X size={18} />
          </button>
        </div>
        <div className="fs-modpanel-grid">
          {group.items.map((item) => {
            const Icon = item.icon;
            const badge = badgeFor(item);
            const desc = ITEM_DESCRIPTIONS[item.menuKey];
            const active = isPathActive(item.path, location);
            return (
              <button
                key={item.path}
                className={`fs-modtile ${active ? 'active' : ''}`}
                onClick={() => onNavigate(item.path)}
                data-testid={`fiori-tile-${item.path.replace(/[/?=]/g, '-').replace(/^-/, '')}`}
              >
                <span className="fs-modtile-icon" aria-hidden="true">{Icon && <Icon />}</span>
                <span className="fs-modtile-body">
                  <span className="fs-modtile-title">
                    {item.label}
                    {badge > 0 && <span className="fs-nav-badge">{badge}</span>}
                  </span>
                  {desc && <span className="fs-modtile-desc">{desc}</span>}
                </span>
                <ChevronRight className="fs-modtile-arrow" size={16} aria-hidden="true" />
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
